import { render } from "./ContentGrowth.vue?vue&type=template&id=5e4731c6&scoped=true"
import script from "./ContentGrowth.vue?vue&type=script&lang=js"
export * from "./ContentGrowth.vue?vue&type=script&lang=js"

import "./ContentGrowth.vue?vue&type=style&index=0&id=5e4731c6&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4731c6"]])

export default __exports__